import { render, staticRenderFns } from "./purchaseAdvance.vue?vue&type=template&id=56bd3090&scoped=true&"
import script from "./purchaseAdvance.vue?vue&type=script&lang=js&"
export * from "./purchaseAdvance.vue?vue&type=script&lang=js&"
import style0 from "./purchaseAdvance.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./purchaseAdvance.vue?vue&type=style&index=1&id=56bd3090&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bd3090",
  null
  
)

export default component.exports